var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBarcode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0070CC",
    d: "M2.344 2a.848.848 0 0 0-.844.857v14.286c0 .475.376.857.844.857h.562a.848.848 0 0 0 .844-.857V2.857A.848.848 0 0 0 2.906 2zm3.094 0a.569.569 0 0 0-.563.571V17.43c0 .314.253.571.563.571.309 0 .562-.257.562-.571V2.57A.569.569 0 0 0 5.437 2Zm2.53 0a.848.848 0 0 0-.843.857v14.286c0 .475.376.857.844.857h.562a.848.848 0 0 0 .844-.857V2.857A.848.848 0 0 0 8.531 2H7.97Zm3.376 0a.849.849 0 0 0-.844.857v14.286c0 .475.376.857.844.857h.562a.848.848 0 0 0 .844-.857V2.857A.849.849 0 0 0 11.906 2zm5.906.857v14.286c0 .475.376.857.844.857h.562a.848.848 0 0 0 .844-.857V2.857A.849.849 0 0 0 18.656 2h-.562a.849.849 0 0 0-.844.857M15 2.571V17.43c0 .314.253.571.563.571s.562-.257.562-.571V2.57c0-.314-.253-.571-.563-.571S15 2.257 15 2.571"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBarcode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/barcode.7fad55320898d811eb08cfbb8c20b61f.svg";